import * as React from 'react';
import { TInputType } from '@cian/ui-kit/input/types';
import { FormFieldInput, useDeviceType, Button } from '@cian/ui-kit';
import { InfoText } from '../InfoText';
import * as styles from './styles.css';

export interface IPhoneFieldProps {
  value: string;
  isValid: boolean;
  error: string;
  fetching: boolean;

  onChange(value: string): void;

  onSubmit(value: string): void;
}

export const PhoneField: React.FC<IPhoneFieldProps> = ({ value, onChange, error, isValid, onSubmit, fetching }) => {
  const isMobile = useDeviceType() === 'phone';
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
    [onChange],
  );

  const handleSubmit = React.useCallback(() => onSubmit(value), [onSubmit, value]);

  return (
    <div data-testid="PhoneField" className={styles['container']}>
      <FormFieldInput
        invalid={!!error}
        type={'tel' as TInputType}
        placeholder="+7"
        onChange={handleChange}
        disabled={fetching}
        errorMessage={error}
        value={value}
        autoFocus
      />
      <div className={styles['info']}>
        <InfoText />
      </div>
      <div data-testid="btn_handleSubmit" className={styles['submit']}>
        <Button size={isMobile ? 'M' : 'XS'} disabled={!isValid} onClick={handleSubmit} loading={fetching}>
          Дальше
        </Button>
      </div>
    </div>
  );
};

PhoneField.displayName = 'PhoneField';
